import * as React from "react";
import * as ReactDatetimeClass from "react-datetime";
import * as moment from "moment";


class DateTimePicker extends React.PureComponent<any, any> {
  render() {
    let onChange = function(val) {
      this.props.onChange(val);
    }.bind(this);

    let value = this.props.value;
    if (value && !moment.isMoment(value) && moment(value).isValid()) {
      value = moment(value);
    }

    return (
      <ReactDatetimeClass
        className={this.props.className}
        onBlur={this.props.onBlur}
        onChange={onChange}
        onFocus={this.props.onFocus}
        value={value}
        viewMode={this.props.viewMode}
        dateFormat={this.props.dateFormat || "DD/MM/YYYY"}
        timeFormat={this.props.timeFormat || false}
        inputProps={{ placeholder: this.props.dateFormat || "DD/MM/YYYY", className: `form-control ${this.props.inputStyle}`}}
        input={true}
        closeOnSelect={true}
      />
    );
  }
}

export default DateTimePicker;
